export default __webpack_public_path__ + "static/media/frontpage.994b1ea2.txt";